__turbopack_context__.v({
  "container": "FacebookTab-module-scss-module__PQz50a__container",
  "gridContainer": "FacebookTab-module-scss-module__PQz50a__gridContainer",
});
